<template>
  <div class="container">
    <mt-header fixed :title="title" class="head" >
       <router-link to="/imgupdate" slot="left">
        <mt-button  icon='back'></mt-button>
       </router-link>
      <mt-button slot="right" v-show="auth.editable" @click="commit">提交</mt-button>
    </mt-header>
    <div class="c_hide form">
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          材料是否进场
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
            <span class="item-value">
               <mt-switch v-model="isready"></mt-switch>
            </span>
        </div>
      </div>
    </div>
    <div class="c_hide table c_p_10" v-if="materials && materials.length>0">
      <div class="table-title c_flex c_flex_center c_flex_between c_nowrap">
        <div>物料名称</div>
        <div>物料数量</div>
        <div>物料状态</div>
      </div>
      <div v-for="(n,index) of materials" :key="index" class="table-item c_flex c_flex_center c_flex_between c_nowrap c_m_t_10">
        <div>{{n.title}}</div>
        <div>{{n.price}}</div>
        <div>{{n.state}}</div>
      </div>
    </div>
    <div class="procedure">
      <div class="procedure-group">
        <div class="procedure-title">混凝土基层({{img_material.length}}/2)</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_material" :key="index" v-if="index<imgNum.img_material">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_material',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="(img_material.length<imgNum.img_material) && auth.editable" @fileChange="getUrl($event,'img_material')"></update-file>
        </div>
        <div class="procedure-memo">
          <div>1、	照片：堵漏宝修补基层缺陷部位和大面远景各一张</div>
          <div>2、	合格准则：基层坚实平整，干净、无裂纹、脱皮、麻面和起砂</div>
        </div>
      </div>
      <div class="procedure-group">
        <div class="procedure-title">金属屋面({{img_qrcode.length}}/4)</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_qrcode" :key="index" v-if="index<imgNum.img_qrcode">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_qrcode',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="(img_qrcode.length<imgNum.img_qrcode) && auth.editable" @fileChange="getUrl($event,'img_qrcode')"></update-file>
        </div>
        <div class="procedure-memo">
          <div>1、	照片：板材拼接缝、螺钉处、清理完的大面远景、涂完灰浆底涂的大面远景</div>
          <div>2、	合格准则：板材拼接缝处无变形、松动螺钉已更换，大面干净无锈蚀；灰浆防水层均匀连续无露底，无开裂现象</div>
        </div>
      </div>
      <div class="procedure-group">
        <div class="procedure-title">采光天窗({{img_basic_start.length}}/2)</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_basic_start" :key="index" v-if="index<imgNum.img_basic_start">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_basic_start',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="(img_basic_start.length<imgNum.img_basic_start) && auth.editable" @fileChange="getUrl($event,'img_basic_start')"></update-file>
        </div>
        <div class="procedure-memo">
          <div>1、	照片：玻璃板材拼缝、远景大面</div>
          <div>2、	合格准则：原老化密封胶已清理干净，大面干净整洁无破损</div>
        </div>
      </div>
      <div class="c_hide procedure-group">
        <div class="procedure-title">拆除中</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_basic_during" :key="index" v-if="index<3">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_basic_during',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="(img_basic_during.length<3)&&auth.editable" @fileChange="getUrl($event,'img_basic_during')"></update-file>
        </div>
      </div>
      <div class="c_hide procedure-group">
        <div class="procedure-title">拆除后</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_basic_end" :key="index" v-if="index<3">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_basic_end',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="(img_basic_end.length<3) && auth.editable" @fileChange="getUrl($event,'img_basic_end')"></update-file>
        </div>
      </div>
      <div class="procedure-group">
        <div class="procedure-title">备注</div>
        <div class="procedure-content" :class="auth.editable?'':'c_no_pointer'">
          <textarea v-model="memo" placeholder="备注" cols="30" rows="10" @change="autoSave('memo',memo)"></textarea>
        </div>
      </div>
    </div>
    <!--图片显示-->
    <c-imgshow @part_close="part_close" :ispart_imgshow="ispart_imgshow" :imgshow_url="imgshow_url">
    </c-imgshow>
  </div>
</template>
<script>
import axios from 'axios'
import UpdateFile from './update-file';
import CImgshow from './c-imgshow';
import {Indicator, MessageBox} from 'mint-ui';
export default {
  components:{UpdateFile,CImgshow},
  data(){
    return{
      qiniu:this.$$api.mobile.qiniuDownload,
        isready:false,
        img_material:[],
        img_qrcode:[],
        img_basic_start:[],
        img_basic_during:[],
        img_basic_end:[],
        imgNum:{
          img_material:2,
          img_qrcode:4,
          img_basic_start:2,
        },
        memo:'',
        sid:'',
        formid:'',
        title:'',
        materials:[
            // {title:'卷材',price:'3',state:'已分配'},
            // {title:'卷材',price:'4',state:'已分配'},
            // {title:'卷材',price:'7',state:'已分配'},
        ],
      // 图片显示
      ispart_imgshow:false,
      imgshow_url:'',
      // 权限控制
      auth:{
        // 是否开启自动保存
        isAutoSave:false,
        //是否有提交权限
        editable:false,
        //是否 可以提交
        isCommit:true,
      },
    }
  },
  mounted(){
    var obj = JSON.parse(localStorage['obj']);
    var procedure = obj.procedure;
    this.sid = procedure.billbid;
    this.formid = procedure.formid;
    this.itemid = procedure.itemid;
    this.title = procedure.itemname;
    this.load();
    this.getAuth();
  },
  methods:{
    // 获取工序详情
    load:function(){
      var $that = this;
      this.$ajax.get(this.$$api.mobile.getProcedureDetail,{
        'sid':this.sid,
        'formid':this.formid
      },function (res) {
        if(res.status ==200) {
          var obj = res.data.detailMsg.data;
          $that.isready = (obj.isready == 'true')||false;
          $that.img_material = obj.img_material ? (obj.img_material.split(',')||[]):[];
          $that.img_qrcode = obj.img_qrcode ? (obj.img_qrcode.split(',')||[]):[];
          $that.img_basic_start = obj.img_basic_start ? (obj.img_basic_start.split(',')||[]):[];
          $that.img_basic_during = obj.img_basic_during ? (obj.img_basic_during.split(',')||[]):[];
          $that.img_basic_end = obj.img_basic_end ? (obj.img_basic_end.split(',')||[]):[];
          $that.memo = obj.memo;
          $that.materials = obj.materials;
        }
        setTimeout(function(){
          $that.auth.isAutoSave = true;
        },500);
      });
    },
    // 获取当前用户权限
    getAuth:function(){
      var $that = this;
      this.$ajax.get(this.$$api.mobile.getProcedureAuth,{
        'itemid':this.itemid,
        'billbid':this.sid,
      },function (res) {
        if(res.status ==200) {
          var obj = res.data.detailMsg.data;
          $that.auth.editable = obj.editable == 'Y'? true:false;
        }
      });
    },
    // 上传图片
    imgFile:function(type,file,fun){
      var $that = this;
      $that.$indicator.open();
      this.$ajax.get(this.$$api.mobile.getimgtoken,{},function (res) {
        if(res.status == 200){
          var token = res.data.token;
          var fileid = res.data.fileid;
          let param = new FormData(); //创建form对象
          param.append('file',file,file.name);//通过append向form对象添加数据
          param.append('chunk','0');//添加form表单中其他数据
          param.append('token',token);//添加form表单中其他数据
          param.append('key',fileid);//添加form表单中其他数据
          let config = {
            headers:{'Content-Type':'multipart/form-data'}
          };
          axios.post($that.$$api.mobile.qiniuUpload,param,config)
            .then(data=>{
              var key = data.data.key;
              if(fun)fun(key);
              $that.$indicator.close();
            });
        }
      });

    },
    // 删除图片
    delClick:function(type,index){
      if(type == 'img_material'){
        var arr = this.img_material;
        arr.splice(index,1);
        this.img_material = arr;
      }else if(type == 'img_qrcode'){
        var arr = this.img_qrcode;
        arr.splice(index,1);
        this.img_qrcode = arr;
      }else if(type == 'img_basic_start'){
        var arr = this.img_basic_start;
        arr.splice(index,1);
        this.img_basic_start = arr;
      }else if(type == 'img_basic_during'){
        var arr = this.img_basic_during;
        arr.splice(index,1);
        this.img_basic_during = arr;
      }else if(type == 'img_basic_end'){
        var arr = this.img_basic_end;
        arr.splice(index,1);
        this.img_basic_end = arr;
      }
    },
    getUrl(e,val){
        var $that = this;
        // var file = e.files[0];
        var file = this.$comm.toBase64(e.base64);
        if(val=='img_material'){
            this.imgFile('img_material',file,function (url) {
              $that.img_material.push(url);
            });
            Indicator.close();
        }else if(val=='img_qrcode'){
            this.imgFile('img_qrcode',file,function (url) {
              $that.img_qrcode.push(url);
            });
            Indicator.close();
        }else if(val=='img_basic_start'){
            this.imgFile('img_basic_start',file,function (url) {
              $that.img_basic_start.push(url);
            });
            Indicator.close();
        }else if(val=='img_basic_during'){
            this.imgFile('img_basic_during',file,function (url) {
              $that.img_basic_during.push(url);
            });
            Indicator.close();
        }else if(val=='img_basic_end'){
            this.imgFile('img_basic_end',file,function (url) {
              $that.img_basic_end.push(url);
            });
            Indicator.close();
        }
    },
    autoSave(type,value){
      if(type && this.sid &&this.formid && this.auth.isAutoSave) {
        this.$ajax.get(this.$$api.mobile.saveProcedure, {
          'sid': this.sid,
          'formid': this.formid,
          'attribute': type,
          'value': value
        }, response => {
          if (response.status >= 200 && response.status < 300) {
            // console.log(response);
          } else {
            // console.log(response,this.sid);
          }
        });
      }
    },
    commit:function () {
      var $that = this;
      // if(this.img_material.length < this.imgNum.img_material){ this.$toast("请上传最少"+this.imgNum.img_material+"张混凝土基层图片");return;}
      // if(this.img_qrcode.length < this.imgNum.img_qrcode){ this.$toast("请上传最少"+this.imgNum.img_qrcode+"张金属屋面图片");return;}
      // if(this.img_basic_start.length < this.imgNum.img_basic_start){ this.$toast("请上传最少"+this.imgNum.img_basic_start+"张采光天窗图片");return;}
      // if(this.img_basic_during.length <3){ this.$toast("请上传最少三张拆除中图片");return;}
      // if(this.img_basic_end.length <3){ this.$toast("请上传最少三张拆除后图片");return;}
      if(!this.auth.isCommit){return;}
      this.auth.isCommit = false;
      this.auth.editable = false;
      this.$ajax.post(this.$$api.mobile.commitProcedure,{
        'sid':this.sid,
        'formid':this.formid,
      },function (res) {
        $that.$router.push('/imgupdate');
      },function () {
        $that.auth.isCommit = true;
        $that.auth.editable = true;
      });
    },
    // 图片预览
    imgShowClick:function (e) {
      var url = e.currentTarget.dataset.src;
      if(url){
        this.imgshow_url = url;
        this.ispart_imgshow = true;
      }
    },
    part_close:function (value) {
      this.ispart_imgshow = value;
    },
  },
  watch:{
    isready(){
      this.autoSave('isready',this.isready||false);
    },
    img_material(){
      this.autoSave('img_material',(this.img_material).join(','));
    },
    img_qrcode(){
      this.autoSave('img_qrcode',(this.img_qrcode).join(','));
    },
    img_basic_start(){
      this.autoSave('img_basic_start',(this.img_basic_start).join(','));
    },
    img_basic_during(){
      this.autoSave('img_basic_during',(this.img_basic_during).join(','));
    },
    img_basic_end(){
      this.autoSave('img_basic_end',(this.img_basic_end).join(','));
    },
  }
}
</script>
<style scoped>
  .container{
    font-size:5vw;
  }
  ::-webkit-input-placeholder {
    font-size: 4vw;
    color: #000;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-group {
    width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    padding: 3.226vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item-title {
    width: 50%;
    text-align: left;
    height: 100%;

  }

  .item-content {
    width: 50%;
    text-align: right;
    font-size: 4vw;
    /*background: blue;*/
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-content input {
    font-size: 4vw;
  }

  .item-value {
    width: 90%;
    display: inline-block;
    height: 100%;
    padding: 0;
    margin: 0;
    color:#000;
  }

  .item-value input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    text-align: right;
    padding: 0;
    margin: 0;
    display: flex;
    align-content: center;
    /*background: red;*/
  }
  .mint-switch{
    justify-content: flex-end;
  }



</style>




// WEBPACK FOOTER //
// src/components/construction-2.vue